import * as React from "react";
import classnames from "classnames";
import {ICurrentStyles} from "shubhform/utils";

interface IRadioButton {
    name: string;
    value: string;
    fieldName: string;
    checked: boolean;
}

interface IRadioButtonProps {
    buttonList: IRadioButton[];
    label: string;
    fieldName: string;
    errorMsg: string;
    onChangeHandler: any;
    index: number;
    value: string;
    currentStyles: ICurrentStyles;
    disabled: boolean;
}

const RadioButtonField: React.FC<IRadioButtonProps> = (props)  => {
    return (
        <div style={props.currentStyles.containerStyle}>
            <div>{props.label}</div>
            {props.buttonList.map((item, index) => {
                let inputStyle: any = props.currentStyles.inputStyle;
                if (item.value === props.value) {
                    inputStyle = {...props.currentStyles.inputStyle, ...props.currentStyles.inputStyle.onSelect};
                }
                return (
                    <button
                        disabled={!!props.disabled}
                        key={index}
                        type="button"
                        style={inputStyle}
                        onClick={() => props.onChangeHandler(props.index, item.value)}
                    >
                        {item.name}
                    </button>
                );
            })}
            {props.errorMsg && <div style={props.currentStyles.errorStyle}>
                {props.errorMsg}
            </div>}
        </div>
    );
};

export default RadioButtonField;
